import { API_ROUTES } from '@/constants/apiRoutes';
import type { AxiosInstance } from 'axios';
import { Commission } from '../commissions/commissions.types';

export interface ToggleStatusPayload {
  actionPlatform?: string;
  categoryId: string;
  status: 'A' | 'B';
}

const toggleStatusComissionType = (client: AxiosInstance) => async (payload: ToggleStatusPayload) => {
  return (
    await client.post<{ message: string; data: Commission }>(API_ROUTES.UPDATE_COMMISSION_CATEGORY_STATUS, {
      categoryId: payload.categoryId,
      status: payload.status,
    })
  ).data;
};

export const commissionsTypeMutations = {
  toggleStatusComissionType,
};
